const hostname = typeof window !== 'undefined'
    ? window.location.hostname
    : 'sportprogress.ru';

const LEGAL_ENTITIES = {
    'sportprogress.ru': {
        name: 'ИП Муровлянникова Д.А.',
        nameShort: 'ИП Муровлянникова Д.А.',
        inn: '',
        showInn: true,
        country: 'RU',
        currency: 'RUB',
        privacyEmail: 'privacy@sportprogress.ru',
        supportEmail: 'support@sportprogress.ru',
    },
    'sportprogress.app': {
        name: 'Individual Entrepreneur Galstyan Termine Galusti',
        nameShort: 'IE Galstyan T.G.',
        taxNumber: '',
        showTaxNumber: true,
        country: 'AM',
        currency: 'USD',
        privacyEmail: 'privacy@sportprogress.app',
        supportEmail: 'support@sportprogress.app',
    },
    'sportprogress.online': {
        name: 'Individual Entrepreneur Galstyan Termine Galusti',
        nameShort: 'IE Galstyan T.G.',
        taxNumber: '',
        showTaxNumber: true,
        country: 'AM',
        currency: 'EUR',
        privacyEmail: 'privacy@sportprogress.online',
        supportEmail: 'support@sportprogress.online',
    },
};

const DEFAULT_ENTITY = LEGAL_ENTITIES['sportprogress.ru'];

function resolveHostname(host) {
    if (!host) return 'sportprogress.ru';
    const bare = host.replace(/^www\./, '');
    if (LEGAL_ENTITIES[bare]) return bare;
    if (bare.endsWith('.sportprogress.ru')) return 'sportprogress.ru';
    if (bare.endsWith('.sportprogress.app')) return 'sportprogress.app';
    if (bare.endsWith('.sportprogress.online')) return 'sportprogress.online';
    return 'sportprogress.ru';
}

const resolvedHost = resolveHostname(hostname);

export function getLegalEntity() {
    return LEGAL_ENTITIES[resolvedHost] || DEFAULT_ENTITY;
}

export function isRussianRegion() {
    return resolvedHost === 'sportprogress.ru';
}

/** Регион для API юридических документов (по домену SPA). */
export function getRegionFromHostname() {
    switch (resolvedHost) {
        case 'sportprogress.ru':
            return 'CIS';
        case 'sportprogress.app':
            return 'EAST';
        case 'sportprogress.online':
            return 'EUROPE';
        default:
            return 'CIS';
    }
}
